import { render, staticRenderFns } from "./suspects.vue?vue&type=template&id=381274cc"
import script from "./suspects.vue?vue&type=script&lang=js"
export * from "./suspects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports